module.exports = __webpack_public_path__ + "img/web-project-4.ccddf13c.svg";